import { store } from "../State/Store";
import { decPending } from "../State/UiSlice";

const MIN_LOADER_MS = 500;

// type gợi ý cho meta (nếu em dùng TS)
export type MetaConfig = {
  skipLoader?: boolean;
  silent?: boolean;
  loaderStartedAt?: number;
};

export function scheduleDecPending(meta?: MetaConfig) {
  if (meta?.skipLoader) return;

  const started = meta?.loaderStartedAt ?? Date.now();
  const elapsed = Date.now() - started;
  const remaining = MIN_LOADER_MS - elapsed;

  if (remaining > 0) {
    setTimeout(() => {
      store.dispatch(decPending());
    }, remaining);
  } else {
    store.dispatch(decPending());
  }
}
